import "react-app-polyfill/ie9"
import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import {UIProvider} from './context/UIContext'
import {ConfigProvider} from './context/ConfigContext'
import {DrawingProvider} from './context/DrawingContext'
import {LocaleProvider} from './context/LocaleContext'
import {RecurrenceProvider} from './context/RecurrenceContext'
import {UserProvider} from './context/UserContext'
// Override ARCHIBUS library methods
import './overrides'
import * as Google from './api/archibus/GoogleApi'
import {GlobalStyle} from './styles/global'
import {Grommet, grommet} from 'grommet'

// Initialize Google Analytics
Google.initializeGoogleAnalytics()
  .then(() => console.log('Google Analytics initialized.'))
  .catch(error => console.log('Google Analytics error: ', error))

ReactDOM.render(
  <LocaleProvider>
    <ConfigProvider>
      <UIProvider>
        <UserProvider>
          <DrawingProvider>
            <RecurrenceProvider>
              <GlobalStyle />
              <Grommet theme={grommet}>
                <App />
              </Grommet>
            </RecurrenceProvider>
          </DrawingProvider>
        </UserProvider>
      </UIProvider>
    </ConfigProvider>
  </LocaleProvider>,

  document.getElementById('app')
)
